import filter from 'lodash/filter';
import get from 'lodash/get';

import { entities } from 'pages/store/schema';
import { getValue, getValues } from 'pages/store/selectors';

export const getCCTerminalByGatewayConfigID = (gatewayConfigID) => (state) =>
  filter(
    getValues(entities.ccTerminal)(state),
    (ccTerminal) => get(ccTerminal, 'gatewayConfigID') === gatewayConfigID
  );

export const getTeminalLastUsedShop = (terminalID) => (state) => {
  const shops = getValues(entities.shop)(state);
  const terminal = getValue(entities.ccTerminal, terminalID)(state);

  return find(shops, (shop) => get(shop, 'shopID') === get(terminal, 'shopID'));
};

export const getTerminals = (state) => getValues(entities.ccTerminal)(state);

export default getCCTerminalByGatewayConfigID;
